import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div className="footer__left">
          <div className="footer__brand">Emmanuel Obeng</div>
          <div className="footer__sub">Results Driven Project Management & IT Services</div>
        </div>
        <div className="footer__right">
          <div className="footer__meta">© {new Date().getFullYear()} Emmanuel Obeng</div>
          <div className="footer__meta">Certified PMP® | ITIL | Scrum | Security+</div>
        </div>
      </div>
    </footer>
  );
}
